// @ts-nocheck
class McCompareProducts extends HTMLElement {
  connectedCallback() {
    this._tbody = this.querySelector('.mc-compare__tbody');
    this._toggleBtn = this.querySelector('.mc-compare__toggle-btn');

    if (!this._tbody || !this._toggleBtn) return;

    this._boundToggle = this._handleToggle.bind(this);
    this._toggleBtn.addEventListener('click', this._boundToggle);
  }

  disconnectedCallback() {
    if (this._boundToggle) {
      this._toggleBtn.removeEventListener('click', this._boundToggle);
    }
  }

  _handleToggle() {
    const isExpanded = this._toggleBtn.getAttribute('aria-expanded') === 'true';
    this._toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
    this._tbody.classList.toggle('mc-compare__tbody--show-all', !isExpanded);
    this._syncLabel(!isExpanded);
  }

  _syncLabel(isExpanded) {
    const label = this._toggleBtn.querySelector('.mc-compare__toggle-label');
    if (label) {
      const { showAllLabel, showFewerLabel } = this._toggleBtn.dataset;
      label.textContent = isExpanded ? showFewerLabel : showAllLabel;
    }
  }
}

customElements.define('mc-compare-products', McCompareProducts);
